import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketSessionzi1ianvyj32u as WebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/WebSocketSession.mjs';
import { DefaultWebSocketSession3h8506yqzs5fx as DefaultWebSocketSession } from '../../../../../../ktor-ktor-websockets/io/ktor/websocket/DefaultWebSocketSession.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultClientWebSocketSessionClass;
function DefaultClientWebSocketSession() {
  if (DefaultClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, delegate) {
        this.f5t_1 = delegate;
        this.g5t_1 = call;
      }
      *f5b(frame, $completion) {
        yield* this.f5t_1.f5b(frame, $completion);
        return Unit_instance;
      }
      *j4k($completion) {
        yield* this.f5t_1.j4k($completion);
        return Unit_instance;
      }
      b5b(_set____db54di) {
        this.f5t_1.b5b(_set____db54di);
      }
      c5b() {
        return this.f5t_1.c5b();
      }
      d5b() {
        return this.f5t_1.d5b();
      }
      e5b() {
        return this.f5t_1.e5b();
      }
      bw() {
        return this.f5t_1.bw();
      }
      a5b(negotiatedExtensions) {
        this.f5t_1.a5b(negotiatedExtensions);
      }
      z5a() {
        return this.f5t_1.z5a();
      }
    }
    initMetadataForClass($, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession(), DefaultWebSocketSession()], [1, 0]);
    DefaultClientWebSocketSessionClass = $;
  }
  return DefaultClientWebSocketSessionClass;
}
var DelegatingClientWebSocketSessionClass;
function DelegatingClientWebSocketSession() {
  if (DelegatingClientWebSocketSessionClass === VOID) {
    class $ {
      constructor(call, session) {
        this.h5t_1 = session;
        this.i5t_1 = call;
      }
      *f5b(frame, $completion) {
        yield* this.h5t_1.f5b(frame, $completion);
        return Unit_instance;
      }
      *j4k($completion) {
        yield* this.h5t_1.j4k($completion);
        return Unit_instance;
      }
      b5b(_set____db54di) {
        this.h5t_1.b5b(_set____db54di);
      }
      c5b() {
        return this.h5t_1.c5b();
      }
      d5b() {
        return this.h5t_1.d5b();
      }
      e5b() {
        return this.h5t_1.e5b();
      }
      bw() {
        return this.h5t_1.bw();
      }
    }
    initMetadataForClass($, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DelegatingClientWebSocketSessionClass = $;
  }
  return DelegatingClientWebSocketSessionClass;
}
//region block: exports
export {
  DefaultClientWebSocketSession as DefaultClientWebSocketSession1n8ok3lng45wy,
  DelegatingClientWebSocketSession as DelegatingClientWebSocketSessiono1sywc6weckz,
};
//endregion

//# sourceMappingURL=ClientSessions.mjs.map
